// Message catalogs live in data.mjs (single source of truth, shared with the Node prerender). This
// module just re-exports them with app-facing types. To add/edit copy, edit data.mjs.
import type { Locale } from './config'
import { CATALOG, loadExtraLocales } from './data.mjs'

export type Messages = Record<string, string>

export const CATALOGS: Record<Locale, Messages> = CATALOG
// Lazily pull in the 23 non-base locale catalogs (data.extra.mjs, code-split) on first need.
export { loadExtraLocales }
